import { render, staticRenderFns } from "./manual-resolve.vue?vue&type=template&id=0df2074a"
import script from "./manual-resolve.vue?vue&type=script&lang=js"
export * from "./manual-resolve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports